import React from 'react';
import PropTypes from 'prop-types';

import { OptionsWhyWithoutTIN } from '../types';
import {
  FormField, CheckFormField, SelectFormField,
} from '../../../../../../utils/FormFields';

function PhysicalPersonLegalInfo({
  person,
  changedPerson,
}) {
  const showPerson = changedPerson || person;
  return (
    <React.Fragment>
      {showPerson.PersonAnualIncome !== undefined && (
        <FormField
          label="Anual Income: "
          value={showPerson.PersonAnualIncome}
          name="PersonAnualIncome"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonExtraIncomeVolume !== undefined && (
        <FormField
          label=" Extra Anual Income: "
          value={showPerson.PersonExtraIncomeVolume}
          name="PersonExtraIncomeVolume"
          changedColor={changedPerson}
        />
      )}
       {showPerson.PersonQualification !== undefined && (
        <FormField
          label=" Person Qualification: "
          value={showPerson.PersonQualification}
          name="PersonQualification"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonPatrimonyId !== undefined && (
        <FormField
          label="Patrimony: "
          value={showPerson.PhysicalPersonPatrimonyDescription}
          name="PhysicalPersonPatrimonyId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonProfessionId !== undefined && (
        <FormField
          label="Profession: "
          value={showPerson.PersonProfessionName}
          name="PersonProfessionId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonActivitySectorId !== undefined && (
        <FormField
          label="Activity Sector: "
          value={showPerson.PersonActivitySectorName}
          name="PersonActivitySectorId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonPublicPositionId !== undefined && (
        <FormField
          label="Public Position: "
          value={showPerson.PhysicalPersonPublicPositionName}
          name="PhysicalPersonPublicPositionId"
          description={showPerson.PhysicalPersonPublicPositionId > 1 ? 'PEP' : undefined}
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonLinkId !== undefined && (
        <FormField
          label="Link Person: "
          value={showPerson.PhysicalPersonLinkName}
          name="PhysicalPersonLinkId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonLinkPublicPositionId !== undefined && (
        <FormField
          label="Link Person Public Position: "
          description={showPerson.PersonLinkPublicPositionId > 1 ? 'PEP Related' : undefined}
          value={showPerson.PersonLinkPublicPositionName}
          name="PersonLinkPublicPositionId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonInstitution !== undefined && (
        <FormField
          label="Institution: "
          value={showPerson.PhysicalPersonInstitution}
          name="PhysicalPersonInstitution"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonWebUser !== undefined && (
        <CheckFormField
          label="Web User: "
          value={showPerson.PhysicalPersonWebUser}
          name="PhysicalPersonWebUser"
          initialValue={showPerson.PhysicalPersonWebUser}
          changedColor={changedPerson}
        />
      )}
      {showPerson.PersonCompanyLinkId !== undefined && (
        <FormField
          label="Company Link: "
          value={showPerson.PersonCompanyLinkName}
          name="PersonCompanyLinkId"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonWorkHistoryActivities !== undefined && (
        <FormField
          label="Work History Activities: "
          value={showPerson.PhysicalPersonWorkHistoryActivities}
          name="PhysicalPersonWorkHistoryActivities"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonWorkHistoryYears !== undefined && (
        <FormField
          label="Work History Years: "
          value={showPerson.PhysicalPersonWorkHistoryYears}
          name="PhysicalPersonWorkHistoryYears"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonWorkHistoryRelevantPosition !== undefined && (
        <FormField
          label="Work History Relevant Position: "
          value={showPerson.PhysicalPersonWorkHistoryRelevantPosition}
          name="PhysicalPersonWorkHistoryRelevantPosition"
          changedColor={changedPerson}
        />
      )}
      {showPerson.PhysicalPersonWorkHistoryIncome !== undefined && (
        <FormField
          label="Work History Income: "
          value={showPerson.PhysicalPersonWorkHistoryIncome}
          name="PhysicalPersonWorkHistoryIncome"
          changedColor={changedPerson}
        />
      )}
    </React.Fragment>
  );
}

PhysicalPersonLegalInfo.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object,
};

PhysicalPersonLegalInfo.defaultProps = {
  changedPerson: undefined,
};

export default PhysicalPersonLegalInfo;
